import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxV1 } from '@frontend/api-fax';
import { useAppScopeSelection } from '@frontend/scope';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useNewBlockedFaxEventSubscription = () => {
  const { invalidateListBlockedFaxes } = FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();
  const { selectedLocationIds } = useAppScopeSelection();

  return useWebsocketEventSubscription(NotificationType.INBOUND_BLOCKED_FAX_NOTIFICATION, (payload) => {
    // BE will send fax events to all users - location agnostic,
    // so we need to check if the event is relevant to the user's selected locations before processing it.
    if (!!payload.params.locationId && !selectedLocationIds.includes(payload.params.locationId)) {
      return;
    }

    invalidateListBlockedFaxes();
  });
};
